/* DEPORTE — JS propio, vanilla, un único archivo. Cada init comprueba si
   su elemento existe antes de hacer nada, así sirve para todas las páginas. */

document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initCompare();
  initGallery();
  initVariantPicker();
});

/* Reveals al hacer scroll (IntersectionObserver compartido) */
function initReveal() {
  var els = document.querySelectorAll('.dp-reveal');
  if (!els.length) return;

  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) {
      el.classList.add('dp-visible');
    });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('dp-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -8% 0px' }
  );

  els.forEach(function (el, i) {
    if (!el.style.getPropertyValue('--dp-delay')) {
      el.style.setProperty('--dp-delay', (i % 6) * 90);
    }
    observer.observe(el);
  });
}

/* Comparador antes/después con deslizador (ratón + táctil) */
function initCompare() {
  var wraps = document.querySelectorAll('.dp-compare');
  if (!wraps.length) return;

  wraps.forEach(function (wrap) {
    var afterWrap = wrap.querySelector('.dp-compare__after-wrap');
    var handle = wrap.querySelector('.dp-compare__handle');
    if (!afterWrap || !handle) return;

    var dragging = false;

    function setPos(clientX) {
      var rect = wrap.getBoundingClientRect();
      var pct = ((clientX - rect.left) / rect.width) * 100;
      pct = Math.max(0, Math.min(100, pct));
      wrap.style.setProperty('--dp-compare-pos', pct + '%');
      afterWrap.style.clipPath = 'inset(0 ' + (100 - pct) + '% 0 0)';
    }

    function onDown() {
      dragging = true;
      wrap.classList.add('dp-compare--dragging');
    }
    function onMove(e) {
      if (!dragging) return;
      var clientX = e.touches ? e.touches[0].clientX : e.clientX;
      setPos(clientX);
    }
    function onUp() {
      dragging = false;
      wrap.classList.remove('dp-compare--dragging');
    }

    handle.addEventListener('mousedown', onDown);
    wrap.addEventListener('mousedown', function (e) {
      onDown();
      setPos(e.clientX);
    });
    window.addEventListener('mousemove', onMove);
    window.addEventListener('mouseup', onUp);

    handle.addEventListener('touchstart', onDown, { passive: true });
    wrap.addEventListener(
      'touchstart',
      function (e) {
        onDown();
        setPos(e.touches[0].clientX);
      },
      { passive: true }
    );
    window.addEventListener('touchmove', onMove, { passive: true });
    window.addEventListener('touchend', onUp);

    handle.setAttribute('tabindex', '0');
    handle.addEventListener('keydown', function (e) {
      var current = parseFloat(wrap.style.getPropertyValue('--dp-compare-pos')) || 50;
      if (e.key === 'ArrowLeft') {
        current = Math.max(0, current - 5);
      } else if (e.key === 'ArrowRight') {
        current = Math.min(100, current + 5);
      } else {
        return;
      }
      wrap.style.setProperty('--dp-compare-pos', current + '%');
      afterWrap.style.clipPath = 'inset(0 ' + (100 - current) + '% 0 0)';
    });
  });
}

/* Galería de la página de producto: imagen principal + miniaturas */
function initGallery() {
  var galleries = document.querySelectorAll('[data-dp-gallery]');
  if (!galleries.length) return;

  galleries.forEach(function (gallery) {
    var main = gallery.querySelector('[data-dp-gallery-main]');
    var thumbs = gallery.querySelectorAll('[data-dp-gallery-thumb]');
    if (!main || !thumbs.length) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var full = thumb.getAttribute('data-full');
        if (!full) return;
        main.style.opacity = '0';
        window.setTimeout(function () {
          main.setAttribute('src', full);
          main.style.opacity = '1';
        }, 150);
        thumbs.forEach(function (t) {
          t.classList.remove('dp-active');
        });
        thumb.classList.add('dp-active');
      });
    });
  });
}

/* Selector de color (variantes color): cambia el id oculto del
   formulario, la imagen principal de la galería y el estado activo. */
function initVariantPicker() {
  var pickers = document.querySelectorAll('[data-dp-variant-picker]');
  if (!pickers.length) return;

  pickers.forEach(function (picker) {
    var form = picker.closest('form');
    var hiddenId = form ? form.querySelector('input[name="id"]') : null;
    var gallery = document.querySelector('[data-dp-gallery]');
    var main = gallery ? gallery.querySelector('[data-dp-gallery-main]') : null;
    var swatches = picker.querySelectorAll('[data-dp-swatch]');
    if (!swatches.length) return;

    swatches.forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        swatches.forEach(function (s) {
          s.classList.remove('dp-active');
        });
        swatch.classList.add('dp-active');

        var nameEl = document.querySelector('[data-dp-color-name]');
        if (nameEl) nameEl.textContent = swatch.getAttribute('data-name') || '';

        var variantId = swatch.getAttribute('data-variant-id');
        if (hiddenId && variantId) hiddenId.value = variantId;

        var image = swatch.getAttribute('data-image');
        if (main && image) {
          main.style.opacity = '0';
          window.setTimeout(function () {
            main.setAttribute('src', image);
            main.style.opacity = '1';
          }, 150);
        }
      });
    });
  });
}
